import type { UUID } from '@cmg/common';
import { useCallback } from 'react';

import type { CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchLazyQuery,
  useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchLazyQuery,
} from '../graphql/__generated__';

export function useAddInvestorFirmSalesCoverageEmployeeSearch(tenantId?: UUID) {
  const [loadEmployeesAsCustomer, { loading: loadingAsCustomer }] =
    useCrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchLazyQuery();
  const [loadEmployeesAsAdmin, { loading: loadingAsAdmin }] =
    useCrmManagement_AddInvestorFirmSalesCoverage_AdminEmployeeSearchLazyQuery();

  const loadEmployees = useCallback(
    async (variables: CrmManagement_AddInvestorFirmSalesCoverage_EmployeeSearchQueryVariables) => {
      if (tenantId) {
        const response = await loadEmployeesAsAdmin({
          variables: { ...variables, tenantId },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            underwriterEmployees: response.data?.adminUnderwriterEmployees,
          },
        };
      } else {
        return await loadEmployeesAsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [tenantId, loadEmployeesAsAdmin, loadEmployeesAsCustomer]
  );

  return {
    loadEmployees,
    loading: tenantId ? loadingAsAdmin : loadingAsCustomer,
  };
}
